const BASE_PATH = "record";
export const TELEMEDICINE_BASE_PATH = `${BASE_PATH}/telemedicine`;

export const RecordsEndpoint = {
    NEXT: `${TELEMEDICINE_BASE_PATH}/next`,
    NEXT_BY_ID: `${TELEMEDICINE_BASE_PATH}/next/{id}`,
    INPORGRESS_BY_ID:`${TELEMEDICINE_BASE_PATH}/fetchRecord/{id}`,  
    BY_ID: `${TELEMEDICINE_BASE_PATH}/{id}`,
    SIGNAL: `${TELEMEDICINE_BASE_PATH}/{id}/rawSignal`,
    APPROVE: `${TELEMEDICINE_BASE_PATH}/{id}/approve`,
    UPDATE_CONCLUSION: `${TELEMEDICINE_BASE_PATH}/{id}/conclusion`,
    UPDATE_INTERPRETATION: `${TELEMEDICINE_BASE_PATH}/{id}/interpretation`,
    UPDATE_PARAMETERS: `${TELEMEDICINE_BASE_PATH}/{id}/parameters`,
    PDF: `${TELEMEDICINE_BASE_PATH}/{id}/holter/pdf`
};

export const CONCLUSION_MAX_LENGTH = 5000;

export const DEFAULT_MM_PER_SECOND = 25;
export const DEFAULT_MM_PER_VM = 10;
